import React from 'react';
import { BrutalistCard, BrutalistBadge } from './BrutalistUI';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const GridView = ({ data, onSelectTerm }) => {
  if (data.length === 0) {
    return (
      <div className="text-2xl font-black p-20 text-center border-4 border-black border-dashed bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] uppercase tracking-tighter">
        No matches found in the lexicon.
      </div>
    );
  }

  const getTitleSize = (text) => {
    const len = text.length;
    if (len <= 10) return 'text-3xl';
    if (len <= 13) return 'text-2xl mt-1';
    if (len <= 16) return 'text-xl mt-1.5';
    return 'text-lg mt-2';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      {data.map((item) => (
        <BrutalistCard 
          key={item.id} 
          color={item.color} 
          onClick={() => onSelectTerm(item)}
          className="flex flex-col h-full min-h-[320px]"
        >
          {/* Header Bar */}
          <div className="bg-black/5 border-b-2 border-black p-4 flex justify-between items-center bg-white/40 backdrop-blur-sm">
            <BrutalistBadge className="max-w-[140px]">{item.category}</BrutalistBadge>
            <span className="font-mono text-[10px] font-black uppercase bg-black text-white px-1.5 py-0.5 border border-white/20">
              {item.dateAdded}
            </span>
          </div>

          {/* Content Body */}
          <div className="p-6 flex-grow flex flex-col overflow-hidden">
            <h2 
              className={`${getTitleSize(item.term)} font-black mb-3 uppercase leading-[0.9] tracking-tighter whitespace-nowrap overflow-hidden text-ellipsis`}
              title={item.term}
            >
              {item.term}
            </h2>
            <p className="text-sm font-bold mb-6 flex-grow line-clamp-4 leading-snug opacity-80">
              {item.plainEnglish}
            </p>

            {/* Tags / Footer */}
            <div className="mt-auto space-y-4">
              <div className="flex flex-wrap gap-1.5">
                {Array.isArray(item.keyTerms) && item.keyTerms.slice(0, 3).map((tag, idx) => (
                  <span key={idx} className="text-[9px] font-black bg-black text-white px-2 py-0.5 uppercase tracking-wider">
                    #{tag}
                  </span>
                ))}
              </div>
              
              <div className="flex items-center justify-between pt-4 border-t-2 border-black border-dashed">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-black animate-pulse" />
                  <span className="text-[10px] font-black uppercase opacity-60">Ready to Review</span>
                </div>
                <div className="bg-black text-white p-2 border-2 border-black shadow-[2px_2px_0px_0px_rgba(255,255,255,1)] group-hover:bg-white group-hover:text-black transition-colors">
                  <SafeIcon icon={FiIcons.FiArrowUpRight} className="text-xl" />
                </div>
              </div>
            </div>
          </div>

          {/* Decorative Corner */}
          <div className="absolute top-0 right-0 w-8 h-8 bg-black transform translate-x-4 -translate-y-4 rotate-45" />
        </BrutalistCard>
      ))}
    </div>
  );
};

export default GridView;